import type { NextPageWithLayout } from "@/shared/lib/types/layoutTypes";
import { AuthLayout } from "@/widgets/AuthLayout";
import { AuthFormFeaturesUi } from "@features/AuthFormFeatures";
import SignInWidget from "@widgets/SignInWidget";

const SignIn: NextPageWithLayout = () => {
	return (
		<AuthFormFeaturesUi.AuthFormLayout imageAltText="Sign In Image">
			<SignInWidget />
		</AuthFormFeaturesUi.AuthFormLayout>
	);
};

SignIn.getLayout = AuthLayout;

export default SignIn;
